<template>
  <cv-skeleton-text
    class="ff-skeleton"
    :paragraph="true"
    :line-count="lines"
    :width="'100%'"
  />
</template>

<script>

export default {
  name: 'ff-skeleton',
  props: [
    'lines',
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-skeleton {

    ::v-deep .bx--skeleton__text {
      height: $unit-3;
      border-radius: $borderRadius;
      margin-bottom: $unit-1;

      &::before {
        border-radius: $borderRadius;
      }
    }
  }

</style>
